CalendarBox = window.CalendarBox || {};

CalendarBox.init = function(selector, options) {
    var $el = $(selector);
    CalendarBox.initFilter($el);
    CalendarBox.initNav($el);
    CalendarBox.initFullCalendar($el, options);
};

CalendarBox.initNav = function($el) {
    var calendarContent = $('.calendarContent', $el);

    $('.calendarHeader .prevMonth', $el).click(function(e) {
        e.preventDefault();
        calendarContent.fullCalendar('prev');
    });
    $('.calendarHeader .nextMonth', $el).click(function(e) {
        e.preventDefault();
        calendarContent.fullCalendar('next');
    });
};

CalendarBox.initFilter = function($el) {
    $('.calendarCategories a', $el).click(function(e) {
        e.preventDefault();
        var $this = $(this);
        var $li = $this.parents('li');
        if ($this.hasClass('all')) {
            $('.calendarCategories li:not(.all)').removeClass('active');
            $li.addClass('active');
        }
        else {
            var $all = $('.calendarCategories a.all').parents('li');
            if ($li.hasClass('active')) {
                $li.removeClass('active');
                if ($('.calendarCategories .active').length === 0) {
                    $all.addClass('active');
                }
            }
            else {
                $all.removeClass('active');
                $li.addClass('active');
            }
        }
        CalendarBox.runFilter($el);
    });
};

CalendarBox.runFilter = function(context) {
    if ($('.calendarCategories').length > 0) {
        if ($('.calendarCategories .active a.all', context).length !== 0) {
            $('.fc-event, .calendarEventList li', context).show();
        }
        else {
            $('.fc-event, .calendarEventList li', context).hide();
            $('.calendarCategories li.active', context).each(function() {
                var $this = $(this);
                $('.fc-event.' + $this.find('a').attr('class') + ', .calendarEventList .' + $this.find('a').attr('class'), context).show();
            });
        }
    }
};

CalendarBox.initFullCalendar = function($el, options) {
    var o = Object.assign(options, CalendarBox.fullCalendarOptions);
    CalendarBox.fullCalendarOptions = CalendarBox.fullCalendarOptions.modifyOptions(o);
    $('.calendarContent', $el).fullCalendar(CalendarBox.fullCalendarOptions);
};

CalendarBox.fullCalendarOptions = {
    eventAfterAllRender: function() {
        CalendarBox.runFilter();
    },
    eventClick: function (calEvent, jsEvent, view) {
        if (CalendarBox.fullCalendarOptions.eventOpensInDialog && calEvent.url) {
            var params = calEvent.url.split('/');
            if (params.length > 1) {
                var url = '/_/' + params[1] + '/calendar/event/view/' + params[params.length-1]
                    + '?moreLink=' + calEvent.url;

                $('#fullcalendarDialog')
                    .load(url)
                    .dialog({
                        width:300,
                        resize: false,
                        draggable: false,
                        dialogClass: 'eventDialog',
                    });
            }
            return false;
        }
    },
    loading: function (isLoading, view) {
        view.el.parents('.fc-view-container').toggleClass('loading', isLoading);
    },
    viewRender: function (view, $el) {
        CalendarBox.fullCalendarOptions.beforeRender($el);

        var $content = $el.parents('.fc-view-container'),
            $calendar = $el.parents('.box_custom');

        // Add the month name to custom header
        $('.calendarHeader .monthName', $calendar).html(view.title);

        if ($content.find('.loadingIndicator').length === 0) {
            $content.append('<div class="loadingIndicator"><img src="/static/local/calendar/img/spinner.png" /></div>')
        }
    },
    beforeRender: function($el) {
    },
    modifyOptions: function(o) {
        o.events = {
            url: o.source,
            cache: true
        };
        //o.defaultView = $(window).width() < 765 ? 'listMonth' : 'month';
        o.locale = $('html').attr('lang') === 'is' ? 'is' : 'en';

        return o;
    }
};
